export const AUTH_HEADERS = 'femtasy-app-AUTH_HEADERS';
export const INFLUENCER_PARAMS = 'femtasy-app-INFLUENCER_PARAMS';
export const IS_REMINDER_HIDDEN = 'femtasy-app-IS_REMINDER_HIDDEN';
export const IS_VERIFIED = 'femtasy-app-IS_VERIFIED';
export const USED_DISCOUNT_CODE = 'femtasy-app-USED_DISCOUNT_CODE';
export const USER_PLANS = 'femtasy-app-USER_PLANS';
export const UTM_PARAMS = 'femtasy-app-UTM_PARAMS';
export const REFERRER = 'femtasy-app-REFERRER';
export const PLAY_NEXT_PROMO_COOKIE = 'PLAY_NEXT_PROMO';
